import { Component, EventEmitter, OnInit, OnDestroy,
  Output, ViewChild, ElementRef } from '@angular/core';
import { MessagesService } from 'src/app/service/messages.service';
import { MessageService } from 'primeng/api';
import { Country } from 'src/app/interfaces/Country';
//import { run } from 'node:test';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-newchatmodalcomp',
  templateUrl: './newchatmodalcomp.component.html',
  styleUrls: ['./newchatmodalcomp.component.scss'],
  providers: [MessageService]
})

export class NewchatmodalcompComponent implements OnInit, OnDestroy {

  @Output() ncModal: EventEmitter<any> = new EventEmitter();
  @Output() mostrarMensaje: EventEmitter<any> = new EventEmitter();

  errorTelefono = false;
  mensajeErrorTelefono = "El teléfono debe tener al menos 8 caracteres";
  phoneNumber: string = '';

  countries: Country[] = [];
  countriesFilter!: Country[];
  countryCodeSelected: string = "";
  showCountryList: boolean = false; // Para mostrar/ocultar la lista
  paisSeleccionado: boolean = false;
  idDispositivo: number | null = null;

  @ViewChild("inputPais") inputPais!: ElementRef


  constructor(private messagesservice: MessagesService, private route: ActivatedRoute,
    private translate: TranslateService) {
    messagesservice.dispositivo$().subscribe(data => {
      this.idDispositivo = data == null ? null : data.id;
    });
    // Establecer idiomas disponibles y el idioma por defecto
    translate.addLangs(['en', 'es']);
    translate.setDefaultLang('es');
  }

  ngOnDestroy(): void {
    this.phoneNumber = "";
    this.countryCodeSelected = "";
    this.showCountryList = false;
    this.paisSeleccionado = false;
  }

  ngOnInit(): void {
    this.messagesservice.getCountries().subscribe(countries => {
      this.countries = countries;
      this.countriesFilter = countries;
    });
    // Obtener el parámetro 'lang' de la URL
    this.route.queryParams.subscribe(params => {
      const lang = params['lang'];
      if (lang) {
        this.translate.use(lang);
      } else {
        this.translate.use('es'); // Idioma por defecto
      }
    });
  }

  
  sendCNCM() {
    this.errorTelefono = false;
    if (this.countryCodeSelected === "") {
      this.errorTelefono = true;
      this.mensajeErrorTelefono = this.translate.instant('NEWCHATMODAL_ERROR_CODE_COUNTRY');
      return;
    }
    const phoneNumber = this.phoneNumber; 
    if (phoneNumber.replace(/\D/g, '').length < 8) {
      this.errorTelefono = true;
      this.mensajeErrorTelefono = this.translate.instant('NEWCHATMODAL_ERROR_PHONE_MIN');
      return;
    }
    if (phoneNumber.replace(/\D/g, '').length > 10) {
      this.errorTelefono = true;
      this.mensajeErrorTelefono = this.translate.instant('NEWCHATMODAL_ERROR_PHONE_MAX');
      return;
    }

    if(this.idDispositivo == null){ return; }
  
    this.messagesservice.getChatId(Number.parseInt(this.countryCodeSelected), phoneNumber,this.idDispositivo)
      .then(response => {
        if (response.success) {
          this.ncModal.emit(false);
          const chatId = response.data.chatId;
          this.messagesservice.infoContacto(chatId);
          this.phoneNumber = ''; 
          this.countryCodeSelected = '';
          this.messagesservice.setSelectedChat(null);
        }
      })
      .catch(error => {
        if(error.error){
          this.mostrarMensaje.emit({
            severity: 'error',
            summary: this.translate.instant('NEWCHATMODAL_EXIST_NUMBER'),
            detail: this.translate.instant('NEWCHATMODAL_ALERT_ERROR_NUMBER')+(error.error.message != null ? " "+error.error.message : ".")+""
          });
          return;
        }

        console.error("Error al agregar nuevo contacto.",error)
        this.mostrarMensaje.emit({
          severity: 'error',
          summary: 'Error',
          detail: this.translate.instant('NEWCHATMODAL_ALERT_ERROR_NUMBER')
        });
      });
  }
  

  toggleCountryList(enfocarInput: boolean) {
    if (enfocarInput) {
      this.inputPais.nativeElement.focus();
    }
    this.errorTelefono = false;
    this.showCountryList = !this.showCountryList;
    if (!this.showCountryList) {
      this.inputPais.nativeElement.blur();
      const numericValue: string = this.countryCodeSelected.replace(/[^0-9]/g, '');
      this.countryCodeSelected = numericValue;
    }

  }
  

  selectCountry(country: Country) {
    this.countryCodeSelected = country.callingCodes[0];
    this.showCountryList = false; 
    this.paisSeleccionado = true;
    this.countriesFilter = this.countries;
  }

  onInputPais(event: any) {
    const inputValue = event.target.value;
    if (!this.paisSeleccionado) {
      const searchText = this.normalizeText(inputValue);
      this.countriesFilter = this.countries.filter(country => {
        const countryNormal = this.normalizeText(country.name);
        return countryNormal.includes(searchText);
      })
      return;
    }

    this.countryCodeSelected = "";
    this.paisSeleccionado = false;
  }

  onInputNumber(event: any) {
    const inputValue = event.target.value;
    const numericValue: string = inputValue.replace(/[^0-9]/g, '');
    if (numericValue.length > 10) {
      const numericValueTen = numericValue.substring(0,10);
      this.phoneNumber = numericValueTen;
      event.target.value = numericValueTen;
    }else{
      this.phoneNumber = numericValue;
      event.target.value = numericValue;
    }
  }

  private normalizeText(text: string): string {
    return text
      .toLowerCase() // Convertir a minúsculas
      .normalize('NFD') // Normalizar caracteres a su forma canónica
      .replace(/[\u0300-\u036f]/g, ''); // Eliminar acentos y diacríticos
  }
}


